import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'

import { userService } from 'src/services/user.service'
import { useLogout } from '../auth'
import { ROUTES } from 'src/constants'

const useRemoveMe = () => {
  const navigate = useNavigate()
  const { logout } = useLogout()
  return useMutation(() => userService.removeMe(), {
    onSuccess: async (data) => {
      if (!data) return

      await logout()
      navigate(ROUTES.LOGIN)
    },
  })
}

export { useRemoveMe }
